import { createStore, applyMiddleware, combineReducers } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunk from 'redux-thunk'

import { reducer as datatableReducer } from './store.reducer'

const middleware = [thunk]

const store = {} as { [key: string]: any }

export const getStore = (key: string) => store[key]

export const makeStore = (key: string) => {
	if (store[key]) {
		return
	}
	store[key] = createStore(
		combineReducers({ datatable: datatableReducer }),
		process.env.NODE_ENV === 'production'
			? applyMiddleware(...middleware)
			: composeWithDevTools(applyMiddleware(...middleware)),
	)
}
